export default "__VITE_ASSET__v1B7a5yK__"